// @flow

export default (t: (name: string) => string, scheduledReportsEnabled: boolean) => ({
  order: ["*"],
  scheduledReportAccess: {
    "ui:field": "multi-select",
    items: {
      "ui:options": {
        hidelabel: true,
      },
    },
    "ui:options": {
      label: t("PERMITTED_USERS"),
      description: t("PERMITTED_USERS_DESCRIPTION"),
      rowBackground: !scheduledReportsEnabled && "light-grey",
    },
  },
  autoDisabling: {
    "ui:widget": "number-input",
    "ui:options": {
      label: t("AUTO_DISABLE"),
      description: t("AUTO_DISABLE_DESCRIPTION"),
      rowBackground: !scheduledReportsEnabled && "light-grey",
    },
  },
  reportsExpiry: {
    "ui:widget": "number-input",
    "ui:options": {
      label: t("REPORTS_EXPIRY"),
      description: t("REPORTS_EXPIRY_DESCRIPTION"),
      rowBackground: !scheduledReportsEnabled && "light-grey",
    },
  },
});
